import { render, staticRenderFns } from "./maildetail.vue?vue&type=template&id=62ddd469"
import script from "./maildetail.vue?vue&type=script&lang=js"
export * from "./maildetail.vue?vue&type=script&lang=js"
import style0 from "./maildetail.vue?vue&type=style&index=0&id=62ddd469&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports